"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeData = exports.normalizeBalanceFullData = exports.genSectionDataTransformer = exports.combineAccountBalances = exports.leverageConvert = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const Models_1 = require("../Models");
/**
 * 处理杠杆代币icon转换展示
 * @param coin
 */
function leverageConvert(coin) {
    let coinName = coin;
    const matchleverage = coinName.match("[0-9][L|S]");
    if (matchleverage && matchleverage.length > 0) {
        const currency = coinName.substr(0, coinName.length - 2);
        const leverage = coinName.substr(coinName.length - 2, 1);
        if (coinName.endsWith("L")) {
            coinName = `${currency}${leverage}P`;
        }
        else {
            coinName = `${currency}${leverage}M`;
        }
    }
    return coinName;
}
exports.leverageConvert = leverageConvert;
/**
 * 组装账户币种资产
 * @param priceConfig
 * @param coinList
 */
function combineAccountBalances(priceConfig, coinList) {
    const renderBalances = coinList
        .filter((item) => item !== null && item !== undefined)
        .map((b) => {
        var _a;
        let totalAmount = new trade_utils_lib_1.SafeDecimal(new trade_utils_lib_1.SafeDecimal(b.assets)).add(new trade_utils_lib_1.SafeDecimal(b.debts));
        if ("unrealized_pnl" in b) {
            totalAmount = totalAmount.add(new trade_utils_lib_1.SafeDecimal((_a = b === null || b === void 0 ? void 0 : b.unrealized_pnl) !== null && _a !== void 0 ? _a : 0));
        }
        const coinConfig = priceConfig[b.coin];
        const coinName = leverageConvert(b.coin);
        // 处理 totalAmount 精度问题，可能会超过8位
        if (new trade_utils_lib_1.SafeDecimal(trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(totalAmount, 8)).equals(0)) {
            totalAmount = new trade_utils_lib_1.SafeDecimal(0);
        }
        const priceInUSD = totalAmount.mul(new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_usd));
        const priceInBTC = totalAmount.mul(new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_btc));
        const start_usd = new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_usd).div(new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.change_24h_in_usd).add(1));
        const diff_usd = new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_usd).sub(start_usd);
        const start_btc = new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_btc).div(new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.change_24h_in_btc).add(1));
        const diff_btc = new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_btc).sub(start_btc);
        return Object.assign(Object.assign({}, b), { change_24h_percent: coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.change_24h_in_usd, originCoin: coinName, totalAmount: totalAmount.toString(), price_in_usd: priceInUSD.toString(), price_in_btc: priceInBTC.toString(), change_24h_in_usd: totalAmount.mul(diff_usd).toString(), change_24h_in_btc: totalAmount.mul(diff_btc).toString(), full_name: coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.full_name });
    });
    return renderBalances;
}
exports.combineAccountBalances = combineAccountBalances;
function combineDisplayList(type, priceConfig, list) {
    if (type === Models_1.MainGroupTypeEnum.spot) {
        return combineAccountBalances(priceConfig, list);
    }
    else if ([
        Models_1.MainGroupTypeEnum.trading_bot,
        Models_1.MainGroupTypeEnum.copy_trade,
        Models_1.MainGroupTypeEnum.lending,
        Models_1.MainGroupTypeEnum.staking,
        Models_1.MainGroupTypeEnum.shark_fin,
    ].includes(type)) {
        const renderBots = list
            .filter((item) => item !== null && item !== undefined)
            .map((botItem) => {
            const totalAmount = new trade_utils_lib_1.SafeDecimal(botItem.investment_amount).add(new trade_utils_lib_1.SafeDecimal(botItem.profit));
            const coinConfig = priceConfig[botItem.investment_token];
            return Object.assign(Object.assign({}, botItem), { totalValue: totalAmount.mul(new trade_utils_lib_1.SafeDecimal(coinConfig === null || coinConfig === void 0 ? void 0 : coinConfig.price_in_usd)).toString() });
        });
        return renderBots;
    }
    else {
        return list !== null && list !== void 0 ? list : [];
    }
}
function genSectionDataTransformer(priceConfig) {
    return (section) => {
        return {
            title: section.title,
            key: section.type,
            data: combineDisplayList(section.type, priceConfig, section.list || []),
            has_more: !!section.has_more,
            count: section.count,
        };
    };
}
exports.genSectionDataTransformer = genSectionDataTransformer;
function normalizeBalanceFullData(obj) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const _prices = {};
    const _bot_account = { total_in_usdt: "0", title: "", detail: [] };
    const _trader_account = { total_in_usdt: "0", title: "", detail: [] };
    if ("prices" in obj) {
        const coinPrices = obj.prices;
        for (const key in coinPrices) {
            const priceConfig = key && coinPrices[key];
            if (key && priceConfig) {
                const _config = {
                    price_in_usd: (_a = priceConfig.price_in_usd) !== null && _a !== void 0 ? _a : "0",
                    price_in_btc: (_b = priceConfig.price_in_btc) !== null && _b !== void 0 ? _b : "0",
                    change_24h_in_usd: (_c = priceConfig.change_24h_in_usd) !== null && _c !== void 0 ? _c : "0",
                    change_24h_in_btc: (_d = priceConfig.change_24h_in_btc) !== null && _d !== void 0 ? _d : "0",
                    full_name: (_e = priceConfig.full_name) !== null && _e !== void 0 ? _e : "",
                };
                _prices[key] = _config;
            }
        }
    }
    if ("bot_account" in obj) {
        const botAccount = obj.bot_account;
        if (botAccount) {
            _bot_account.title = (_f = botAccount.title) !== null && _f !== void 0 ? _f : "";
            _bot_account.total_in_usdt = (_g = botAccount.total_in_usdt) !== null && _g !== void 0 ? _g : "0";
            _bot_account.detail = ((_h = botAccount.detail) !== null && _h !== void 0 ? _h : [])
                .filter((e) => e !== null && e !== undefined)
                .map((item) => {
                var _a, _b, _c, _d, _e, _f;
                let _list = ((_a = item.list) !== null && _a !== void 0 ? _a : []).filter((e) => e !== null && e !== undefined);
                switch (item.type) {
                    case Models_1.MainGroupTypeEnum.copy_trade:
                        _list = _list.map((botItem) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            const _item = botItem;
                            return {
                                title: (_a = _item.title) !== null && _a !== void 0 ? _a : "",
                                bu_order_id: (_b = _item.bu_order_id) !== null && _b !== void 0 ? _b : "",
                                bu_order_type: (_c = _item.bu_order_type) !== null && _c !== void 0 ? _c : "",
                                base_list: (_d = _item.base_list) !== null && _d !== void 0 ? _d : [],
                                investment_token: (_e = _item.investment_token) !== null && _e !== void 0 ? _e : "",
                                investment_amount: (_f = _item.investment_amount) !== null && _f !== void 0 ? _f : "0",
                                profit: (_g = _item.profit) !== null && _g !== void 0 ? _g : "0",
                                totalValue: (_h = _item.totalValue) !== null && _h !== void 0 ? _h : "0",
                                copy_from: (_j = _item.copy_from) !== null && _j !== void 0 ? _j : "",
                                cate_type: (_k = _item.cate_type) !== null && _k !== void 0 ? _k : "",
                            };
                        });
                        break;
                    case Models_1.MainGroupTypeEnum.trading_bot:
                        _list = _list.map((botItem) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                            const _item = botItem;
                            return {
                                title: (_a = _item.title) !== null && _a !== void 0 ? _a : "",
                                bu_order_id: (_b = _item.bu_order_id) !== null && _b !== void 0 ? _b : "",
                                bu_order_type: (_c = _item.bu_order_type) !== null && _c !== void 0 ? _c : "",
                                base_list: (_d = _item.base_list) !== null && _d !== void 0 ? _d : [],
                                investment_token: (_e = _item.investment_token) !== null && _e !== void 0 ? _e : "",
                                investment_amount: (_f = _item.investment_amount) !== null && _f !== void 0 ? _f : "0",
                                profit: (_g = _item.profit) !== null && _g !== void 0 ? _g : "0",
                                totalValue: (_h = _item.totalValue) !== null && _h !== void 0 ? _h : "0",
                                cate_type: (_j = _item.cate_type) !== null && _j !== void 0 ? _j : "",
                            };
                        });
                        break;
                    case Models_1.MainGroupTypeEnum.spot:
                        _list = _list
                            .filter((e) => {
                            return e.coin !== null && e.coin !== undefined;
                        })
                            .map((spot) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                            return {
                                coin: (_a = spot.coin) !== null && _a !== void 0 ? _a : "",
                                assets: (_b = spot.assets) !== null && _b !== void 0 ? _b : "0",
                                free: (_c = spot.free) !== null && _c !== void 0 ? _c : "0",
                                frozen: (_d = spot.frozen) !== null && _d !== void 0 ? _d : "0",
                                debts: (_e = spot.debts) !== null && _e !== void 0 ? _e : "0",
                                payable: (_f = spot.payable) !== null && _f !== void 0 ? _f : "0",
                                loan: (_g = spot.loan) !== null && _g !== void 0 ? _g : "0",
                                interest: (_h = spot.interest) !== null && _h !== void 0 ? _h : "0",
                                frozen_by_order: (_j = spot.frozen_by_order) !== null && _j !== void 0 ? _j : "0",
                                frozen_by_moveout: (_k = spot.frozen_by_moveout) !== null && _k !== void 0 ? _k : "0",
                                frozen_by_coinout: (_l = spot.frozen_by_coinout) !== null && _l !== void 0 ? _l : "0",
                            };
                        });
                        break;
                    case Models_1.MainGroupTypeEnum.staking:
                    case Models_1.MainGroupTypeEnum.lending:
                    case Models_1.MainGroupTypeEnum.shark_fin:
                        _list = _list.map((lendingItem) => {
                            var _a, _b, _c, _d, _e;
                            const _item = lendingItem;
                            return {
                                product_id: (_a = _item.product_id) !== null && _a !== void 0 ? _a : "",
                                title: (_b = _item.title) !== null && _b !== void 0 ? _b : "--",
                                investment_token: (_c = _item.investment_token) !== null && _c !== void 0 ? _c : "",
                                investment_amount: (_d = _item.investment_amount) !== null && _d !== void 0 ? _d : "0",
                                profit: (_e = _item.profit) !== null && _e !== void 0 ? _e : "0",
                            };
                        });
                        break;
                    case Models_1.MainGroupTypeEnum.futures_lite:
                        // NOTE: 简易合约 list 数据数据不需要处理，直接返回。list 类型为：FuturesLiteDetail
                        break;
                    default:
                        _list = _list.map((item) => {
                            var _a, _b, _c;
                            const _item = item;
                            return {
                                title: (_a = _item.title) !== null && _a !== void 0 ? _a : "--",
                                investment_token: (_b = _item.investment_token) !== null && _b !== void 0 ? _b : "",
                                investment_amount: (_c = _item.investment_amount) !== null && _c !== void 0 ? _c : "0",
                            };
                        });
                        break;
                }
                return {
                    type: (_b = item.type) !== null && _b !== void 0 ? _b : "",
                    title: (_c = item.title) !== null && _c !== void 0 ? _c : "",
                    total_in_usdt: (_d = item.total_in_usdt) !== null && _d !== void 0 ? _d : "0",
                    list: _list,
                    has_more: (_e = item.has_more) !== null && _e !== void 0 ? _e : false,
                    count: (_f = item.count) !== null && _f !== void 0 ? _f : 0, //_list.length
                };
            });
        }
    }
    if ("trader_account" in obj) {
        const traderAccount = obj.trader_account;
        if (traderAccount) {
            _trader_account.title = (_j = traderAccount.title) !== null && _j !== void 0 ? _j : "";
            _trader_account.total_in_usdt = (_k = traderAccount.total_in_usdt) !== null && _k !== void 0 ? _k : "0";
            _trader_account.detail = ((_l = traderAccount.detail) !== null && _l !== void 0 ? _l : [])
                .filter((e) => e !== null && e !== undefined)
                .map((item) => {
                var _a, _b, _c, _d, _e, _f;
                return {
                    type: (_a = item.type) !== null && _a !== void 0 ? _a : "",
                    title: (_b = item.title) !== null && _b !== void 0 ? _b : "",
                    total_in_usdt: (_c = item.total_in_usdt) !== null && _c !== void 0 ? _c : "0",
                    risk_state: (_d = item.risk_state) !== null && _d !== void 0 ? _d : "",
                    balances: ((_e = item.balances) !== null && _e !== void 0 ? _e : [])
                        .filter((e) => e !== null && e !== undefined)
                        .map((b) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                        return {
                            coin: (_a = b.coin) !== null && _a !== void 0 ? _a : "",
                            assets: (_b = b.assets) !== null && _b !== void 0 ? _b : "0",
                            free: (_c = b.free) !== null && _c !== void 0 ? _c : "0",
                            frozen: (_d = b.frozen) !== null && _d !== void 0 ? _d : "0",
                            debts: (_e = b.debts) !== null && _e !== void 0 ? _e : "0",
                            payable: (_f = b.payable) !== null && _f !== void 0 ? _f : "0",
                            loan: (_g = b.loan) !== null && _g !== void 0 ? _g : "0",
                            interest: (_h = b.interest) !== null && _h !== void 0 ? _h : "0",
                            available: (_j = b.available) !== null && _j !== void 0 ? _j : "0",
                            unrealized_pnl: (_k = b.unrealized_pnl) !== null && _k !== void 0 ? _k : "0",
                            total_initial_margin: (_l = b.total_initial_margin) !== null && _l !== void 0 ? _l : "0",
                            transferable: (_m = b.transferable) !== null && _m !== void 0 ? _m : "0",
                        };
                    }),
                    positions: ((_f = item.positions) !== null && _f !== void 0 ? _f : [])
                        .filter((e) => e !== null && e !== undefined)
                        .map((p) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                        return {
                            symbol: (_a = p.symbol) !== null && _a !== void 0 ? _a : "",
                            position_id: (_b = p.position_id) !== null && _b !== void 0 ? _b : "",
                            position_side: (_c = p.position_side) !== null && _c !== void 0 ? _c : "",
                            qty_long: (_d = p.qty_long) !== null && _d !== void 0 ? _d : "0",
                            qty_short: (_e = p.qty_short) !== null && _e !== void 0 ? _e : "0",
                            amount_long: (_f = p.amount_long) !== null && _f !== void 0 ? _f : "0",
                            amount_short: (_g = p.amount_short) !== null && _g !== void 0 ? _g : "0",
                            amount_settle: (_h = p.amount_settle) !== null && _h !== void 0 ? _h : "0",
                            mark_price: (_j = p.mark_price) !== null && _j !== void 0 ? _j : "0",
                            initial_margin: (_k = p.initial_margin) !== null && _k !== void 0 ? _k : "0",
                            maint_margin: (_l = p.maint_margin) !== null && _l !== void 0 ? _l : "0",
                            maint_price: (_m = p.maint_price) !== null && _m !== void 0 ? _m : "0",
                            leverage: (_o = p.leverage) !== null && _o !== void 0 ? _o : "0",
                            risk_flag: (_p = p.risk_flag) !== null && _p !== void 0 ? _p : "",
                            created_time: Number((_q = p.created_time) !== null && _q !== void 0 ? _q : 0),
                            updated_time: Number((_r = p.updated_time) !== null && _r !== void 0 ? _r : 0),
                            qty_liquidated: (_s = p.qty_liquidated) !== null && _s !== void 0 ? _s : "0",
                            amount_liquidated: (_t = p.amount_liquidated) !== null && _t !== void 0 ? _t : "0",
                        };
                    }),
                };
            });
        }
    }
    return {
        total_in_usdt: (_m = obj.total_in_usdt) !== null && _m !== void 0 ? _m : "0",
        total_in_btc: (_o = obj.total_in_btc) !== null && _o !== void 0 ? _o : "0",
        prices: _prices,
        bot_account: _bot_account,
        trader_account: _trader_account,
    };
}
exports.normalizeBalanceFullData = normalizeBalanceFullData;
function mergeData(value) {
    var _a;
    const normalizeValue = normalizeBalanceFullData(value);
    const priceConfig = normalizeValue.prices;
    const botAccount = normalizeValue[Models_1.HoldingGroupType.bot_account];
    const futuresAccount = normalizeValue[Models_1.HoldingGroupType.futures_account];
    const sectionDataTransformer = genSectionDataTransformer(priceConfig);
    const sections = ((_a = botAccount.detail) !== null && _a !== void 0 ? _a : []).map(sectionDataTransformer);
    return {
        list: sections,
        futuresAccount,
        botAccount,
        total: {
            totalInUSD: normalizeValue.total_in_usdt,
            totalInBTC: normalizeValue.total_in_btc,
        },
        /**不同币种的价格 */
        prices: priceConfig,
    };
}
exports.mergeData = mergeData;
